import { useCompaniesExist } from "../../../hooks/useCompanies";
import { useRestaurantSchema } from "../../../hooks/useRestaurantSchema";

/**
 * Кои секции на менюто на Справки имат смисъл за заведението:
 * „Резервации" — само ако в схемата има поне една маса (в който и да е район);
 * „Фискални" — само ако има поне една фирма.
 * Докато отговорът не е дошъл (или при грешка) секцията се показва — крие се
 * само при потвърдено „няма".
 */
export function useReportSectionsVisibility() {
  const { data: regions } = useRestaurantSchema();
  const { data: companiesExist } = useCompaniesExist();

  const hasTables =
    regions === undefined ||
    regions.some((r) => r.elements.some((e) => e.kind === "table"));

  return {
    showReservations: hasTables,
    showFiscal: companiesExist !== false,
  };
}
